import bannerShop from "./bannerShop"
export default bannerShop;
